<template>
  <div class="dataTables_filter d-flex ml-0">
    <div class="mr-2">
      <div class="input-group">
        <input
          v-model="q"
          @keydown.enter.prevent="search()"
          type="text"
          name="search"
          :placeholder="$t('Search...')"
          style="min-width:175px"
          class="border-right-0 form-control pl-2 px-0"
        >
        <span class="input-group-append"><button
          @click="search()"
          type="button"
          class="btn btn-outline-normal border-left-0 btn-search"
        ><i class="far fa-search" /></button></span>
      </div>
    </div>

    <div class="d-flex">
      <div class="toolbar-filter">
        <div class="btn-group">
          <div class="filter-date">
            <div class="input-group">
              <span class="input-group-prepend">
                <span class="input-group-text"><i class="fas fa-calendar-alt" /></span>
              </span>
                        
              <date-range-picker
                format="'YYYY-MM-DD H:i:s'"
                :ranges="ranges"
                style="min-width:175px"
                v-model="$parent.filters.dateRange"
                :locale-data="localedata"
                :control-container-class="'form-control rounded-left-0 rounded-right-0'"
              >
                <div
                  slot="input"
                  v-html="showTextPicker"
                />
                <div
                  slot="footer"
                  slot-scope="data"
                  class="drp-buttons p-2"
                >
                  <button
                    @click="cancelDateRange()"
                    v-if="!data.in_selection"
                    type="button"
                    class="applyBtn btn  btn-secondary"
                  >
                    {{ $t('Cancel') }}
                  </button>
                  <button
                    @click="data.clickApply"
                    v-if="!data.in_selection"
                    type="button"
                    class="applyBtn btn  btn-primary "
                  >
                    {{ $t('Apply') }}
                  </button>
                </div>
              </date-range-picker>
            </div>
          </div>
          <button
            @click="openAdvanceFilter"
            data-toggle="modal"
            data-target="#advance_filter"
            type="button"
            class="btn btn-outline-normal rounded-left-0 d-flex"
          >
            <i class="fas fa-sliders-v mr-2 mt-1" />
            {{ $t("More Filters") }}
            <span
              v-if="$parent.countFilter"
              class="badge badge-secondary ml-2"
            >{{ $parent.countFilter }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
    clearfilters,
    showTextPicker
} from './../../directives/Vuetable.js'

import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from "moment";
import { convertTimezone } from "@/common/tenancy/convertTimezone";
export default {
    name: "FilterBar",

    data() {
        return {
            q: '',
            filterSummary:0,
            localedata: {
                format: 'dd/mm/yyyy',
                applyLabel: this.$t('Apply'),
                cancelLabel: this.$t('Cancel'),
                clearable: true,
                monthNames: this.$storeIndex.monthNames(),
                daysOfWeek: this.$storeIndex.daysOfWeek(),
            },
            ranges: this.$storeIndex.ranges(),
        }
    },
    components: {
        moment,
        DateRangePicker

    },
    methods: {
        openFiltersMore() {
            this.$parent.isFiltersMore = false;

            this.$nextTick(() => {
                this.$parent.isFiltersMore = true;
            });
        },
        search() {
            this.$emit('searchText', this.q);
        },
        updateValues(){
            console.log('UpdateValues');
        },
        applyDatePicker() {

        },
        clearFilter(key) {
            let afterClear = clearfilters(this.$parent.filter, key);
            this.$parent.filter = afterClear;
        },
        stopTheEvent: (event) => event.stopPropagation(),
        cancelDateRange() {
            this.$parent.filters.dateRange.startDate = null;
            this.$parent.filters.startDate = null;

            this.$parent.filters.dateRange.endDate = null;
            this.$parent.filters.endDate = null;
            $('.daterangepicker').remove();
            this.$parent.setParams(this.$parent.filters);
        },
        openAdvanceFilter() {
            this.isadvanceFilter = true;
            this.$nextTick(() => {
                this.isadvanceFilter = true;
            });
        },
    },
    computed: {
        showTextPicker: function () {
            if (this.$parent.filters.dateRange.startDate && this.$parent.filters.dateRange.endDate) {
                this.$parent.dateTxtFilter = showTextPicker(this.$parent.filters.dateRange);
    
                this.$parent.filters.startDate =   moment(this.$parent.filters.dateRange.startDate).format('YYYY-MM-DD');
                this.$parent.filters.endDate   =   moment(this.$parent.filters.dateRange.endDate).format('YYYY-MM-DD');
                
                let afterStartDate = this.$parent.filters.startDate+' 00:00:00';
                let afterEndDate =  this.$parent.filters.endDate+' 23:59:59';
                
                this.$parent.filters.startDate =   convertTimezone.localToUtc(afterStartDate)
                this.$parent.filters.endDate   =   convertTimezone.localToUtc(afterEndDate)
                

                this.$parent.setParams(this.$parent.filters);

                return this.$parent.dateTxtFilter;
            } else {
                return showTextPicker(this.$parent.filters.dateRange);;
            }
        }
    },
    mounted: function () {
        
    },
    watch: {
      
    }
}
</script>


// WEBPACK FOOTER //
// src/components/tenancy/admin/settings/sale/sale-contact/assets/template/vuetable/FiltersBar.vue